import { useMemo } from 'react'

import { PerformanceGoalsAssigneeSelectFieldDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

export const AssigneeSelectField: React.FC<{
  value?: number[]
  error?: string
  touched?: boolean
  onChange: (value: EmployeeSelectorV2MultiSelectState) => void
}> = ({ value, onChange, error, touched }) => {
  const { data, loading } = useQuery(PerformanceGoalsAssigneeSelectFieldDocument)
  const employees = useMemo(() => data?.goals.employees ?? [], [data?.goals.employees])

  const visibleEmployeeIds = useMemo(() => employees.map((employee) => employee.id), [employees])


  return (
    <EmployeeSelectorV2
      label={i18n.t('performance_goals.assignee_select_field.label')}
      messages={{ placeholder: i18n.t('performance_goals.assignee_select_field.placeholder') }}
      forcedFilters={{ employeeIds: visibleEmployeeIds }}
      error={touched ? error : undefined}
      value={value}
      disabled={loading}
      onChange={onChange}
      multiple
    />
  )
}
